module.exports = __webpack_public_path__ + "static/media/main_slider_2.e98a1b6a.jpg";